/* eslint-disable */
import request from './helpers'

export function getConfigList() {
  return request({
    url: '/api/v1/config/groups',
    method: 'get'
  })
}

export function getConfigByGroup(group) {
  return request({
    url: '/api/v1/config/' + group + '/all',
    method: 'get'
  })
}

export function getConfigNames() {
  return request({
    url: '/api/v1/config/configs',
    method: 'get'
  })
}

export function getConfigById(id) {
  return request({
    url: '/api/v1/config/' + id,
    method: 'get'
  })
}

export function updateConfig(id, data) {
  return request({
    url: '/api/v1/config/' + id,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function createConfig(data) {
  return request({
    url: '/api/v1/config',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function deleteConfig (id) {
  return request({
    url: '/api/v1/config/' + id,
    method: 'delete'
  })
}
